export default "__VITE_ASSET__DFZCO2Fn__"